import {Component} from '@angular/core';
import {DropdownAbled} from "../../../shared/interfaces/dropdown-abled";
import {PageInfo} from "../../../shared/model/response/page-info.model";
import {DatePipe} from "@angular/common";
import {PaginatorState} from "primeng/paginator";
import {FeedbackFilterRequestModel} from "../../../shared/model/request/feedback-filter-request.model";
import {FeedbackResponse} from "../../../shared/model/response/feedback-response";
import {FeedbackService} from "../../../service/api/feedback.service";

@Component({
    selector: 'app-feedbacks',
    templateUrl: './feedbacks.component.html',
    standalone: false
})
export class FeedbacksComponent implements DropdownAbled<FeedbackResponse> {

  feedbackList: FeedbackResponse[];
  pagination: PageInfo

  filters: FeedbackFilterRequestModel

  tableHasData: boolean = true

  public mouseEvent: MouseEvent
  selectedObject: FeedbackResponse

  constructor(
    private datePipe: DatePipe,
    private feedbackService: FeedbackService,
  ) {
  }

  ngOnInit() {

  }

  onFilterSubmit(filterData: FeedbackFilterRequestModel) {
    filterData.creationDate = this.datePipe.transform(filterData.creationDate, 'yyyy-MM-dd');
    this.filters = filterData
    this.apiListFeedbacks(this.filters)
  }

  onPageChange($event: PaginatorState) {
    this.apiListFeedbacks(this.filters, $event.page)
  }

  setTableNoData() {
    this.tableHasData = false;
    this.feedbackList = null;
  }


  //api calls ----------------------------------
  apiListFeedbacks(filters: FeedbackFilterRequestModel, page?: number) {
    this.feedbackService.page(page, filters).subscribe({
      next: (value) => {
        this.feedbackList = value?.data
        this.pagination = value.pageInfo
        this.tableHasData = this.feedbackList.length > 0
      },
      error: () => {
        if (page == 0) this.setTableNoData()
      }
    })
  }

  onTerminateFeedback($closedComplaint: FeedbackResponse) {
    this.feedbackList = this.feedbackList.filter(el => el.id !== $closedComplaint.id)
    if (this.feedbackList.length == 0) this.setTableNoData()
  }

  //dropdown interface -------------------------
  selectObjectForDropDown(selectedObject: FeedbackResponse): void {
    this.selectedObject = selectedObject;
  }

  setMouseEvent($mouseEvent: MouseEvent) {
    this.mouseEvent = $mouseEvent
  }
}
